import React, { lazy, Suspense, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import Preloader from "../Miscellaneous/Preloader";

const platformComponents = {
  "connected-mobility": lazy(() => import("./Platform1")),
  "sage-ai": lazy(() => import("./Platform2")),
  "agents-of-mobility": lazy(() => import("./Platform3")),
};

const DynamicPlatform = () => {
  const { platformName } = useParams();
  const location = useLocation();

  useEffect(() => {
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, behavior: 'auto' });
    });
  }, [location.pathname]);

  const DecodedName = decodeURIComponent(platformName);

  const Component = platformComponents[DecodedName];

  return (
    <Suspense fallback={<Preloader />}>
      {Component ? <Component /> : <div>Platform not found</div>}
    </Suspense>
  );
};

export default DynamicPlatform;
